import { ValueOf } from "../type";

export const FolderFileKey = {
  FolderFileById: "FOLDER_FILE_BY_ID",
  FolderFileDocsPdfPage: "FOLDER_FILE_DOCS_PDF_PAGE",
  FolderFilePdfConvertQueue: "FOLDER_FILE_PDF_CONVERT_QUEUE",
} as const;

export type FolderFileKeyType = ValueOf<typeof FolderFileKey>;
